import {SettingsService} from 'src/app/pages/settings/settings.service';
import {ProjectGanttViewComponent} from './../../../widgets/project-gantt-view/project-gantt-view/project-gantt-view.component';

import {OperationType} from './../../../widgets/filters/miscellaneous/operation-type.enum';
import {QueryFilterParameter} from './../../../widgets/filters/models/query-filter-parameter.model';
import {TaskService} from './../../task/task.service';
import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation, inject} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NotificationService} from 'src/app/services/notification.service';
import {Project, ProjectProgressGroup, ProjectProgressMatrixUnit, ProjectService, ProjectTaskStatus, ProjectToProjectTask} from '../project.service';
import {Task} from 'src/app/pages/task/task.service';
import {ActivatedRoute, Data} from '@angular/router';
import {Location} from '@angular/common';
import {StringUtils} from 'src/app/models/utils';
import {TableDataOperator} from 'src/app/operators/table-data.operator';
import {FiltersOperator} from 'src/app/widgets/filters/api/filters-operator.api';
import {SelectStatementResult} from 'src/app/models/select-statement-result.model';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {SelectStatementOptions} from 'src/app/models/select-statement-options.model';
import {DxDataGridComponent} from 'devextreme-angular';

import {DxDataGridOperator} from 'src/app/operators/dx-data-grid.operator';
import {SelectionSetId} from 'src/app/enums/selection-set-id.enum';
import {BaseSelectStatementId} from 'src/app/enums/base-select-statement-id.enum';
import {FiltersGroupBookmarkElementsOperator} from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import {UtilsService} from 'src/app/services/utils.service';
import {firstValueFrom} from 'rxjs';
import {BookmarkElementsOperator} from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import {BookmarkNewComponent} from 'src/app/widgets/bookmark-new/bookmark-new.component';
import {CellPreparedEvent} from 'devextreme/ui/pivot_grid_types';
import {InfoBoxService} from 'src/app/services/info-box.service';

enum AddionalAction {
	None,
	DeleteAllTasks,
	ChangeTasksStatusToDone,
}

@Component({
    selector: 'app-project-deep-dive',
    templateUrl: './project-deep-dive.component.html',
    styleUrls: ['./project-deep-dive.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProjectDeepDiveComponent implements OnInit, AfterViewInit {
	private _infoBoxService: InfoBoxService = inject(InfoBoxService);

	// <Grid>
	@ViewChild('dataGrid', {static: false}) dataGrid: DxDataGridComponent;
	@ViewChild('dataGridBottom', {static: false}) dataGridBottom: DxDataGridComponent;

	public onGridActionItemClicked(item: any) {
		console.log('onGridActionItemClicked - item:', item);

		// When we change this id select box will automatically call `onProjectChanged`.
		this.selectedProjectId = item.data.Id;

		// this.onProjectChanged({ value:  });
	}

	private upsertProjectGridRow(data) {


		let projectToUpdate: Project = this.projects.find((project) => project.id === data.Id);

		if (!data.IsActive && projectToUpdate.isActive) {
			this.inactivatedProject = projectToUpdate;

			this.inactivateProjectAddionalActionConfirmationPopUpVisible = true;
		}

		this.projectService
			.saveProjectGridData(data, {
				showLoadingIndicator: true,
				showErrorNotification: false,
			})
			.subscribe({
				next: (response) => {
					if (response.success) {
						this.initializeProjects(false);
					}
				},
				error: (error) => {
					if (error.status === 409 && !error.error.success) {
						this._infoBoxService.show({
							message: error.error.message,
						});
					} else {
						this.notificationService.error(error);
					}
				},
			});
	}

	public onProjectGridRowInserted(event) {
		console.log('onProjectGridRowInserted - event:', event);

		this.upsertProjectGridRow(event.data);
	}

	public onProjectGridRowUpdated(event) {
		console.log('onProjectGridRowUpdated - event:', event);

		this.upsertProjectGridRow(event.data);
	}

	public onProjectGridRowRemoved(event) {
		console.log('onProjectGridRowRemoved - event:', event);

		this.deleteProject(
			this.projects.find((project) => project.id === event.data.Id),
			true
		);
	}

	public onRemoveProjectGridRow(event) {
		console.log('onRemoveProjectGridRow - event:', event);

		this.deleteProjectTargetProjectId = event.row.data.Id;
		this.deleteProjectConfirmationPopUpVisible = true;
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	fitTableToPage = false;
	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;



		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach((col) => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	fitTableToPageBottom = false;
	changeFitToPageStatusBottom() {
		this.fitTableToPageBottom = !this.fitTableToPageBottom;



		let currentState = this.dataGridBottom.instance.state();
		currentState.columns.forEach((col) => {
			delete col.width;
		});

		this.dataGridBottom.instance.state(currentState);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-project-deep', JSON.stringify(this.dataGrid.instance.state()));
	}

	public dxDataGridOperatorBottom: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReadyBottom(evt) {
		this.dxDataGridOperatorBottom.updateRowCount(evt.component);

		localStorage.setItem('grid-state-project-deep-bottom', JSON.stringify(this.dataGridBottom.instance.state()));
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift(
			{
				location: 'before',
				template: 'expandButtonTemplate',
			},
			{
				location: 'before',
				template: 'heightButtonTemplate',
			}
		);
	}

	public projectsTableDataOperator: TableDataOperator<Project> = new TableDataOperator(
		new SelectStatementOptions({
			filters: async () => this.projectsTableFiltersOperator.appliedFilters,

			baseSelectStatementId: BaseSelectStatementId.DEV_GetProjectDeepDiveGridData,
			selectionSetId: SelectionSetId.ProjectDeepDiveGridDataFields,
		})
	);

	// </Grid>

	// <Filters/Bookmarks>

	@ViewChild('projectsTableBookmarksGroup', {static: false})
	public projectsTableBookmarksGroup: BookmarkNewComponent;

	public taskTableFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions({
			baseSelectStatementId: BaseSelectStatementId.DEV_GetProjectTasksGridData,
			selectionSetId: SelectionSetId.TaskList,
		})
	);

	public projectsTableFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions({
			baseSelectStatementId: BaseSelectStatementId.DEV_GetProjectDeepDiveGridData,
			selectionSetId: SelectionSetId.ProjectDeepDiveGridDataFilters,
		})
	);

	public taskTableBookmarkElementsOperators: BookmarkElementsOperator[];
	public projectsTableBookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.taskTableBookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator({
				id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				filtersOperator: () => this.taskTableFiltersOperator,
			}),
		];

		this.projectsTableBookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator({
				id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				filtersOperator: () => this.projectsTableFiltersOperator,
			}),
		];

		return routeData;
	}

	// </Filters/Bookmarks>

	public async loadPageData() {
		(
			await this.projectsTableFiltersOperator.getObservable({
				showLoadingIndicator: true,
			})
		).subscribe({
			next: async (response) => {
				if (!(await this.projectsTableBookmarksGroup.applyDefaultBookmark())) {
					this.projectsTableDataOperator.load({
						showLoadingIndicator: true,
					});
				}
			},
		});
	}

	public projects: Project[] = [];
	public activeProjects: Project[] = [];
	public projectsToTasks: ProjectToProjectTask[];

	public get selectedProject(): Project {
		return this.projects.find((project) => project.id === this.selectedProjectId);
	}
	public projectProgressGroups: ProjectProgressGroup[] = [];
	public projectTaskStatuses: ProjectTaskStatus[] = [];
	public overallProjectProgress: number = 0;
	public projectTasks: Task[] = [];

	// Matrix data
	public projectProgressMatrixData: ProjectProgressMatrixUnit[] = [];
	public matrixGridDataSource: any;

	public taskTableDataOperator: TableDataOperator<Task> = new TableDataOperator(
		new SelectStatementOptions({
			filters: async () => [...this.taskTableFiltersOperator.appliedFilters, new QueryFilterParameter('ProjectId', this.selectedProjectId.toString(), OperationType.Equals)],

			baseSelectStatementId: BaseSelectStatementId.DEV_GetProjectTasksGridData,
			selectionSetId: SelectionSetId.GeneralProjectDeepDive,
		})
	);

	public taskProgressGroupsDataOperator: TableDataOperator<ProjectProgressGroup> = new TableDataOperator();
	public taskMatrixProgressDataOperator: TableDataOperator<SelectStatementResult> = new TableDataOperator();
	public taskProgressMatrixDataOperator: TableDataOperator<ProjectProgressMatrixUnit> = new TableDataOperator();
	public taskStatusesDataOperator: TableDataOperator<ProjectTaskStatus> = new TableDataOperator();

	public currentlySelectedTask: Task = new Task();
	public showEditTaskPopup = false;

	public loadMatrixProgressData() {
		this.taskMatrixProgressDataOperator.load(
			{
				showLoadingIndicator: true,
			},
			new SelectStatementOptions({
				baseSelectStatementId: 10025,
			})
		);

		this.taskMatrixProgressDataOperator.getObservable().then((promiseResponse) => promiseResponse.subscribe());
	}

	public users: string[];

	// <General page fields>

	public showInfoPopup: boolean;
	public infoPopupMessage: string = 'DEFAULT MESSAGE';

	private readonly _componentTitle = 'Project Deep Dive';
	// private readonly _QueryParamName = "NONE";
	private readonly _projectIdQueryParamName = 'projectId';

	// </General page fields>

	// public currentUrl: string = "";

	@ViewChild('projectGanttView', {static: false}) projectGanttView: ProjectGanttViewComponent;

	public updateURLToSelectedProjectId(): void {
		const url = `general/project-deep-dive?${this._projectIdQueryParamName}=${this.selectedProjectId}`;
		this.location.replaceState(url);
	}

	public initializeProjectProgressGroups() {
		let $this = this;

		let filters = [...this.taskTableFiltersOperator.appliedFilters, new QueryFilterParameter('ProjectId', this.selectedProjectId.toString(), OperationType.Equals)];

		this.taskProgressGroupsDataOperator
			.getObservable(
				{
					showLoadingIndicator: true,
				},
				new SelectStatementOptions({
					baseSelectStatementId: 10023,
					selectionSetId: null,
					filters: filters,
				})
			)
			.then((promiseResponse) => {
				promiseResponse.subscribe({
					next: (res) => {
						$this.projectProgressGroups = res.data;

						for (let i = 0; i <= 100; i += 10) {
							if (!$this.projectProgressGroups.find((x) => x.ProgressGroup == i)) {
								$this.projectProgressGroups.push({Count: 0, ProgressGroup: i, ProjectId: this.selectedProjectId});
							}
						}

						$this.projectProgressGroups.sort((a, b) => (+a.ProgressGroup < +b.ProgressGroup ? -1 : 1));
					},
				});
			});
	}

	public initializeProjectProgressMatrix() {
		let $this = this;

		let filters = [new QueryFilterParameter('ProjectId', this.selectedProjectId.toString(), OperationType.Equals)];

		this.taskProgressMatrixDataOperator
			.getObservable(
				{
					showLoadingIndicator: true,
				},
				new SelectStatementOptions({
					baseSelectStatementId: 10025,
					selectionSetId: null,
					filters: filters,
				})
			)
			.then((promiseResponse) => {
				promiseResponse.subscribe({
					next: (res) => {
						$this.projectProgressMatrixData = res.data;

						$this.projectProgressMatrixData.forEach((x) => {
							if (x.Status == null || x.Status == undefined) {
								x.Status = 'Pending';
							}
						});

						let statuses = ['Done', 'In Progress', 'Pending'];
						let plannedStatuses = ['Planned Pending', 'Planned In Progress', 'Planned Done'];

						for (let i = 0; i < statuses.length; i++) {
							for (let j = 0; j < plannedStatuses.length; j++) {
								if (!$this.projectProgressMatrixData.find((x) => x.Status.toLowerCase() == statuses[i].toLowerCase() && x.PlannedStatus.toLowerCase() == plannedStatuses[j].toLowerCase())) {
									$this.projectProgressMatrixData.push({
										Count: 0,
										PlannedStatus: plannedStatuses[j],
										Status: statuses[i],
										ProjectId: this.selectedProjectId,
									});
								}
							}
						}

						this.matrixGridDataSource = new PivotGridDataSource({
							remoteOperations: false,
							store: $this.projectProgressMatrixData,
							fields: [
								{
									area: 'column',
									dataField: 'PlannedStatus',
									dataType: 'string',
									width: 25,
									sortOrder: 'desc',
								},
								{
									area: 'row',
									dataField: 'Status',
									dataType: 'string',
									width: 25,
									sortOrder: 'desc',
								},
								{
									area: 'data',
									dataField: 'Count',
									dataType: 'number',
									summaryType: 'sum',
									width: 25,
								},
							],
						});
					},
				});
			});
	}

	private _getConditionalAppearance(evt: CellPreparedEvent) {
		let columnPath = <string>evt.cell.columnPath[0];
		let rowPath = <string>evt.cell.rowPath[0];

		const appearanceMap = {
			'Done': {
				'Planned Done': { fill: 'hsla(96, 42%, 48%, 0.87)' },
				'Planned In Progress': { fill: 'hsla(96, 42%, 48%, 0.87)' },
				'Planned Pending': { fill: 'hsla(96, 42%, 48%, 0.87)' }
			},
			'In Progress': {
				'Planned Done': { fill: 'hsla(24, 84%, 42%, 0.87)' },
				'Planned In Progress': { fill: 'hsla(96, 48%, 56%, 0.87)' },
				'Planned Pending': { fill: 'hsla(96, 48%, 56%, 0.87)' }
			},
			'Pending': {
				'Planned Done': { fill: 'hsla(24, 84%, 42%, 0.87)' },
				'Planned In Progress': { fill: 'hsla(24, 84%, 42%, 0.87)' },
				'Planned Pending': { fill: 'hsla(45, 100%, 50%, 0.87)' }
			}
		};

		const defaultAppearance = {
			font: 'hsla(0, 0%, 0%, 0.87)',
			fill: 'hsla(24, 84%, 42%, 0.87)',
			bold: false,
			opacity: 1
		};
		const rowAppearance = appearanceMap[rowPath];
		const cellAppearance = rowAppearance ? rowAppearance[columnPath] : null;

		return cellAppearance ? {...defaultAppearance, ...cellAppearance} : defaultAppearance;
	}

	private _isDataCell(evt: CellPreparedEvent) {
		return evt.area === 'data' && evt.cell.rowType === 'D' && evt.cell.columnType === 'D';
	}

	private _isTotalCell(evt: CellPreparedEvent) {
		return evt.cell.type === 'T' || evt.cell.type === 'GT' || evt.cell.rowType === 'T' || evt.cell.rowType === 'GT' || evt.cell.columnType === 'T' || evt.cell.columnType === 'GT';
	}

	private _getCssStyles({fill, font, bold, opacity}) {
		return {
			'background-color': fill,
			color: font,
			'font-weight': bold ? 'bold' : undefined,
			opacity: opacity,
			'text-align': 'center',
			height: '50px',
			'font-size': '20px',
			'vertical-align': 'middle',
		};
	}

	public onProgressMatrixCellPrepared(evt: CellPreparedEvent) {
		if (this._isDataCell(evt) || this._isTotalCell(evt)) {
			const appearance = this._getConditionalAppearance(evt);
			console.warn(appearance);
			Object.assign(evt.cellElement.style, this._getCssStyles(appearance));
		}
	}

	public customizePointProgressGroups = (arg: any) => {
		if (+arg.data.ProgressGroup >= 0 && +arg.data.ProgressGroup < 30) {
			return {color: '#C55A11', hoverStyle: {color: '#C55A11'}};
		} else if (+arg.data.ProgressGroup >= 30 && +arg.data.ProgressGroup <= 99) {
			return {color: '#FFC000', hoverStyle: {color: '#FFC000'}};
		} else {
			return {color: '#70AD47', hoverStyle: {color: '#70AD47'}};
		}
	};

	public initializeProjectTaskStatuses() {
		let $this = this;

		let filters = [...this.taskTableFiltersOperator.appliedFilters, new QueryFilterParameter('ProjectId', this.selectedProjectId.toString(), OperationType.Equals)];

		this.taskStatusesDataOperator
			.getObservable(
				{
					showLoadingIndicator: true,
				},
				new SelectStatementOptions({
					baseSelectStatementId: 10020,
					selectionSetId: null,
					filters: filters,
				})
			)
			.then((promiseResponse) => {
				promiseResponse.subscribe({
					next: (res) => {
						$this.projectTaskStatuses = res.data;

						const statuses = ['Pending', 'In Progress', 'Done'];

						statuses.forEach((x) => {
							if (!$this.projectTaskStatuses.find((y) => y.Status == x)) {
								$this.projectTaskStatuses.push({
									Count: 0,
									Id: this.selectedProjectId,
									Progress: 0,
									Status: x,
								});
							}
						});

						$this.projectTaskStatuses.sort((a, b) => (a.Status[0] > b.Status[0] ? -1 : 1));

						$this.calculateOverallProgress();
					},
				});
			});
	}

	customizePointTaskStatuses = (arg: any) => {
		if (arg.data.Status == 'Pending') {
			return {color: '#C55A11', hoverStyle: {color: '#C55A11'}};
		} else if (arg.data.Status == 'In Progress') {
			return {color: '#FFC000', hoverStyle: {color: '#FFC000'}};
		} else {
			return {color: '#70AD47', hoverStyle: {color: '#70AD47'}};
		}
	};

	private calculateOverallProgress() {
		let sum = 0;
		let sumCount = 0;
		this.projectTaskStatuses.forEach((x) => {
			sum += x.Progress;
			sumCount += x.Count;
		});

		this.overallProjectProgress = sum / sumCount;
	}

	public refreshAllData($event) {
		setTimeout(() => {
			this.initializeProjects(true, false);
			this.currentlySelectedTask = new Task();
		}, 5000);
	}

	editButtonClicked(e, data) {
		e.event.stopPropagation();

		this.taskService.getCoreTaskById(data.data.TaskId).subscribe((result) => {
			this.currentlySelectedTask = result;

			this.showEditTaskPopup = true;
		});
	}

	public initializeProjects(requestGanttChart: boolean = true, selectFirstProject: boolean = true) {
		console.warn('TESTESTESASDAAAAAAAAAABBBBBBBBZZZZZZZZZ');
		this.projectService
			.getProjects({
				showLoadingIndicator: true,
			})
			.subscribe({
				next: (response) => {
					this.projects = response;
					this.activeProjects = response.filter((project) => project.isActive);

					this.route.queryParamMap.subscribe((queryParams) => {
						console.log('route.queryParamMap - queryParams:', queryParams);

						let id: number = +queryParams.get(this._projectIdQueryParamName);

						console.log(`Query Parameter -> ${this._projectIdQueryParamName}:`, id);

						this._settingsService
							.getCoreSetting(null, 'MainProjectId', true, {
								showLoadingIndicator: true,
							})
							.then((response) => {
								this.mainProjectId = +response.value;

								if (this.activeProjects.length > 0 && (!id || !this.activeProjects.find((project) => project.id === id))) {



									id = this.mainProjectId;
								}

								if (selectFirstProject) this.selectedProjectId = id;

								this.initializeProjectProgressGroups();
								this.initializeProjectProgressMatrix();
								this.initializeProjectTaskStatuses();

								this.taskTableDataOperator.load({
									showLoadingIndicator: true,
								});

								if (requestGanttChart) {
									this.updateURLToSelectedProjectId();

									this.projectGanttView.loadGanttData(this.selectedProjectId);
								}
							});
					});
				},
			});
	}

	// public logEvent(event: any, prefix: string) {
	// 	console.log(prefix + " - event:", event);
	// }

	public deleteProjectTasks(project: Project) {
		console.log('deleteProjectTasks');

		const $this = this;

		this.projectService.deleteProjectTasks(project).subscribe(
			(response) => {
				console.log('deleteProjectTasks -> deleteProjectTasks - response:', response);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					if ($this.activeProjects.length > 0) {
						if ($this.selectedProjectId === project.id) {
							if (!project.isActive) {
								$this.selectedProjectId = $this.activeProjects[$this.activeProjects.length - 1].id;
							}

							$this.updateURLToSelectedProjectId();
							$this.initializeProjectProgressGroups();
							$this.initializeProjectProgressMatrix();
							$this.initializeProjectTaskStatuses();

							this.taskTableDataOperator.load({
								showLoadingIndicator: true,
							});

							$this.projectGanttView.loadGanttData($this.selectedProjectId);
						}
					} else {
						$this.projectGanttView.loadGanttData(null);
					}
				} else {
				}
			},
			(error) => {
				console.error(error);

				// If it's a conflict.
				if (error.status === 409 && !error.error.success) {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = error.error.message;
				} else {
					$this.notificationService.error(error);
				}
			}
		);
	}

	public selectedProjectId: number = null;

	public deleteProject(project: Project, deleteTasks: boolean) {
		console.log('deleteProject');

		const $this = this;

		this.projectService.deleteProject(project, deleteTasks).subscribe(
			(response) => {
				console.log('deleteProject -> deleteProject - response:', response);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					$this.activeProjects.splice(
						$this.activeProjects.findIndex((tmpProj) => tmpProj.id === project.id),
						1
					);
					$this.projects.splice(
						$this.projects.findIndex((tmpProj) => tmpProj.id === project.id),
						1
					);

					$this.projectsTableDataOperator.load();

					if ($this.activeProjects.length > 0) {
						$this.selectedProjectId = $this.activeProjects[$this.activeProjects.length - 1].id;

						$this.updateURLToSelectedProjectId();
						$this.initializeProjectProgressGroups();
						$this.initializeProjectProgressMatrix();
						$this.initializeProjectTaskStatuses();

						this.taskTableDataOperator.load({
							showLoadingIndicator: true,
						});

						$this.projectGanttView.loadGanttData($this.selectedProjectId);
					} else {
						$this.projectGanttView.loadGanttData(null);
					}
				} else {
				}
			},
			(error) => {
				console.error(error);

				// If it's a conflict.
				if (error.status === 409 && !error.error.success) {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = error.error.message;
				} else {
					$this.notificationService.error(error);
				}
			}
		);
	}

	public onProjectChanged(event: any) {
		let projectId = event.value;

		this.selectedProjectId = projectId;

		if (this.selectedProjectId) {
			this.updateURLToSelectedProjectId();
			this.initializeProjectProgressGroups();
			this.initializeProjectProgressMatrix();
			this.initializeProjectTaskStatuses();

			this.taskTableDataOperator.load({
				showLoadingIndicator: true,
			});

			this.projectGanttView.loadGanttData(this.selectedProjectId);
		} else {
			this.projectGanttView.loadGanttData(null);
		}
	}

	// <Misc>

	public deleteProjectConfirmationPopUpVisible: boolean;

	private deleteProjectTargetProjectId: number;

	public onTrashClick(event: any) {
		console.log('onTrashClick - event:', event);

		this.deleteProjectTargetProjectId = this.selectedProjectId;

		this.deleteProjectConfirmationPopUpVisible = true;
	}

	public mainProjectId: number;

	public onMakeMainClick(event: any) {


		this._settingsService
			.setCoreSetting(null, 'MainProjectId', this.selectedProjectId, {
				showLoadingIndicator: true,
			})
			.subscribe({
				next: (response) => {




					this.mainProjectId = this.selectedProjectId;
				},
			});
	}

	public deleteAllTasksCheckBoxValue: boolean = false;

	public onDeleteProjectConfrimButtonClicked() {
		this.deleteProject(
			this.activeProjects.find((project) => project.id === this.deleteProjectTargetProjectId),
			this.deleteAllTasksCheckBoxValue
		);

		this.deleteProjectConfirmationPopUpVisible = false;
	}

	public onDeleteProjectCancelButtonClicked() {
		this.deleteProjectConfirmationPopUpVisible = false;
	}

	public inactivateProjectAddionalActionConfirmationPopUpVisible;

	private inactivatedProject: Project;

	public inactivateProjectAddionalActions = new Array<{name: string; value: AddionalAction}>(
		{name: StringUtils.toDisplayString(AddionalAction[AddionalAction.None]), value: AddionalAction.None},
		{name: StringUtils.toDisplayString(AddionalAction[AddionalAction.DeleteAllTasks]), value: AddionalAction.DeleteAllTasks},
		{name: StringUtils.toDisplayString(AddionalAction[AddionalAction.ChangeTasksStatusToDone]), value: AddionalAction.ChangeTasksStatusToDone}
	);
	public selectedAdditionalAction: {name: string; value: AddionalAction};

	private updateMultipleTasks(tasks: Task[]): void {
		

		this.taskService.updateMultipleTasks(tasks).subscribe();
	}

	public onInactivateProjectAddionalActionConfrimButtonClicked() {


		if (this.selectedAdditionalAction) {
			switch (this.selectedAdditionalAction.value) {
				case AddionalAction.None:
					break;
				case AddionalAction.DeleteAllTasks:
					this.deleteProjectTasks(this.inactivatedProject);

					break;
				case AddionalAction.ChangeTasksStatusToDone:
					// Get all tasks, then filter them to get only tasks of specific project that we have just deactivated and change those tasks satus to 'Done' then update them on backend.
					this.projectService
						.getTasks({
							showLoadingIndicator: true,
						})
						.subscribe({
							next: (getTasksResponse) => {
								let currentProjectToTasks = this.projectsToTasks.filter((x) => x.projectId === this.inactivatedProject.id);

								let tasks: Task[] = getTasksResponse.filter((innerTasks) => {
									return currentProjectToTasks.some((projectToTask) => projectToTask.projectTaskId === innerTasks.taskId);
								});

								for (let a = 0; a < tasks.length; a++) {
									const task = tasks[a];

									task.status = 'Done';
								}

								this.updateMultipleTasks(tasks);
							},
						});

					break;
			}
		}

		this.inactivateProjectAddionalActionConfirmationPopUpVisible = false;
	}

	public onInactivateProjectAddionalActionCancelButtonClicked() {
		this.inactivateProjectAddionalActionConfirmationPopUpVisible = false;
	}

	// </Misc>

	// <Toggles>

	public hideInfoPopup() {
		this.showInfoPopup = false;
	}

	// </Toggles>

	constructor(
		private titleService: Title,
		private _activatedRoute: ActivatedRoute,

		private notificationService: NotificationService,
		private projectService: ProjectService,
		private taskService: TaskService,
		private route: ActivatedRoute,
		private location: Location,

		private _settingsService: SettingsService
	) {}

	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		await this.initializeBookmarks();

		this.taskTableFiltersOperator.load();
		this.taskTableFiltersOperator.onFiltersApplied.subscribe({
			next: (_) => {
				this.taskTableFiltersOperator.load();

				this.taskTableDataOperator.load({
					showLoadingIndicator: true,
				});

				this.initializeProjectProgressGroups();
				this.initializeProjectTaskStatuses();
			},
		});

		this.projectsTableFiltersOperator.onFiltersApplied.subscribe({
			next: (_) => {
				this.projectsTableDataOperator.load({
					showLoadingIndicator: true,
				});
			},
		});

		this.loadPageData();
	}

	ngAfterViewInit(): void {
		this.initializeProjects(false);
	}
}
